<div>
  <h2 id="title" class="paragraph-01-bold">
    Baja de Oficina - Oficina {{ value.name }}
  </h2>
  <!-------------------- Date Inputs -------------------->
  <!---------- Input ---------->
  <div class="input_label_container">
    <div>
      <label class="subheading-01-semi-bold" for="declineDate"
        >Fecha de baja:
      </label>
    </div>
    <input
      name="declineDate"
      type="date"
      class="date-picker"
      value="{{ this.value.declineDate }}"
      (change)="changeDeclineDate($event)"
    />
  </div>
</div>
